/**
 * Created by jacmai on 3/23/2017.
 */

define([
  "marionette",
  "./template/apiRequestValidationTemplate.html",
  "./template/apiRequestVariableTemplate.html",
], function (Marionette, ApiRequestValidationTemplate, ApiRequestVariableTemplate) {
  var ApiRequestValidationView = {};

  ApiRequestValidationView.apiRequestVariableView = Marionette.ItemView.extend({
    template: ApiRequestVariableTemplate,
    className: "control-group",
    collectTestValue: function () {
      this.clearError();
      var testValue = this.$el.find("input").val();
      if (testValue.length > 0) {
        this.model.set("testValue", testValue);
        return true;
      } else {
        this.testValueError();
        return false;
      }
    },
    clearError: function () {
      this.$el.find("div.error-message").hide();
    },
    testValueError: function () {
      this.$el.find("div.error-message").fadeIn();
    },
  });

  ApiRequestValidationView.apiRequestValidationView = Marionette.CompositeView.extend({
    template: ApiRequestValidationTemplate,
    itemView: ApiRequestValidationView.apiRequestVariableView,
    itemViewContainer: "#apiRequestVariables",
    collectTestValues: function () {
      //return true if all of the test variable values are defined, false otherwise
      var returnValue = true;
      this.children.each(function (childView) {
        returnValue = childView.collectTestValue() && returnValue;
      });
      return returnValue;
    },
    clearTestError: function () {
      this.$el.find("#testRequestError").hide();
    },
    displayTestError: function () {
      this.clearSpinner();
      this.$el.find("#testRequestError").fadeIn();
    },
    clearSpinner: function () {
      this.$el.find("#testingRequest").hide();
    },
    displaySpinner: function () {
      this.clearTestError();
      this.$el.find("#testingRequest").show();
    },
  });

  return ApiRequestValidationView;
});
